import { ReactionCodeValue as ReactionCode } from '../../../../reactions/constants';
import { unreachable } from '../../../../ts-utils';
export const resolveNextReactionData = ({ state, initiatorIdentity, }) => {
    const reactions = normalizeReactions(state.reactions);
    switch (state.action) {
        case 'ADD':
            return {
                total: state.total + 1,
                reactions: reactions.map((r) => {
                    return r.reactionCode === state.reactionCode
                        ? incrementReaction(r, initiatorIdentity)
                        : r;
                }),
            };
        case 'REPLACE':
            return {
                total: state.total,
                reactions: reactions.map((r) => {
                    if (r.hasReacted) {
                        return decrementReaction(r, initiatorIdentity);
                    }
                    if (r.reactionCode === state.reactionCode) {
                        return incrementReaction(r, initiatorIdentity);
                    }
                    return r;
                }),
            };
        case 'REMOVE':
            return {
                total: state.total - 1,
                reactions: state.reactions.map((r) => r.hasReacted ? decrementReaction(r, initiatorIdentity) : r),
            };
        default:
            throw unreachable(state.action);
    }
};
export const normalizeReactions = (reactions) => {
    return Object.values(ReactionCode).map((code) => {
        const reaction = reactions?.find((r) => r.reactionCode === code);
        return {
            reactionCode: code,
            hasReacted: reaction?.hasReacted || false,
            total: reaction?.total || 0,
            identities: reaction?.identities || [],
        };
    });
};
const incrementReaction = (reaction, initiatorIdentity) => {
    return {
        ...reaction,
        hasReacted: true,
        identities: initiatorIdentity
            ? [initiatorIdentity, ...reaction.identities]
            : reaction.identities,
        total: reaction.total + 1,
    };
};
const decrementReaction = (reaction, initiatorIdentity) => {
    return {
        ...reaction,
        hasReacted: false,
        identities: initiatorIdentity
            ? reaction.identities.filter((r) => r.identityId !== initiatorIdentity.identityId)
            : reaction.identities,
        total: reaction.total - 1,
    };
};
//# sourceMappingURL=comment-reaction-utils.js.map